import { ContentStoreKeywordsService } from 'src/services/Keywords';

export const deleteKeyword = (
    { accessToken, id }: App.Keyword.DeleteMutationVariables,
): Promise<void> => ContentStoreKeywordsService.deleteKeyword(accessToken, id);
